<label [class.checked]="input.checked">
  <input type="radio" [name]="name" [value]="value" #input />
  <ng-content></ng-content>
</label>
